import React from "react";
import { Button, Typography, Space } from "antd";
import { useKeycloak } from "@react-keycloak/web";

const { Text } = Typography;

const NoPermission = () => {
  const { keycloak } = useKeycloak();

  return (
    <>
      <Space style={{ padding: "30px" }}>
        <Text style={{ fontSize: "25px" }}>
          You do not have the permission to view this page, Please
        </Text>
        <Button
          style={{ fontSize: "25px", padding: "0px", margin: "0px" }}
          onClick={() => keycloak.login()}
          type="link"
        >
          Login.
        </Button>
      </Space>
    </>
  );
};

export default NoPermission;
